import React from 'react';

function AlertModal({ 
  isOpen, 
  onClose, 
  title = "Alert", 
  message, 
  type = "info", // success, error, warning, info
  confirmText = "OK",
  onConfirm
}) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          iconColor: '#10B981',
          borderColor: '#10B981',
          buttonBg: '#10B981',
          buttonHover: '#059669'
        };
      case 'error':
        return {
          iconColor: '#EF4444',
          borderColor: '#EF4444',
          buttonBg: '#EF4444',
          buttonHover: '#DC2626'
        };
      case 'warning':
        return {
          iconColor: '#F59E0B',
          borderColor: '#F59E0B',
          buttonBg: '#F59E0B',
          buttonHover: '#D97706'
        };
      default: // info
        return {
          iconColor: '#00356B',
          borderColor: '#00356B',
          buttonBg: '#00356B',
          buttonHover: '#002A5A'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
      onClick={handleOverlayClick}
    >
      <div 
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '24px',
          margin: '16px',
          maxWidth: '400px',
          width: '100%',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          border: `2px solid ${styles.borderColor}`,
          animation: 'modalSlideIn 0.3s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '16px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: `${styles.iconColor}20`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px'
          }}>
            <span style={{
              fontSize: '20px',
              color: styles.iconColor,
              fontWeight: 'bold'
            }}>
              {type === 'success' ? '✓' : 
               type === 'error' ? '✕' : 
               type === 'warning' ? '⚠' : 'ℹ'}
            </span>
          </div>
          <h3 style={{
            margin: 0,
            fontSize: '18px',
            fontWeight: '600',
            color: '#1F2937'
          }}>
            {title}
          </h3>
        </div>

        {/* Message */}
        <p style={{
          margin: '0 0 24px 0',
          fontSize: '14px',
          color: '#6B7280',
          lineHeight: '1.5'
        }}>
          {message}
        </p>

        {/* Button */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={handleConfirm}
            style={{
              backgroundColor: styles.buttonBg,
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              minWidth: '80px'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = styles.buttonHover;
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = styles.buttonBg;
              e.target.style.transform = 'translateY(0)';
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AlertModal;
